import NavBar from "./components/NavBar";
import HeroSection from "./components/HeroSection";
import EditorialSection from "./components/EditorialSection";
import ProductGallery from "./components/ProductGallery";
import BrandPositioning from "./components/BrandPositioning";
import CustomJewelrySection from "./components/CustomJewelrySection";
import VisualBreak from "./components/VisualBreak";
import TestimonialsSection from "./components/TestimonialsSection";
import CTASection from "./components/CTASection";
import FooterSection from "./components/FooterSection";

export default function HomePage() {
  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <main
      className="overflow-x-hidden"
      style={{ scrollBehavior: "smooth" }}
    >
      <NavBar onNavigate={scrollToSection} />
      <section>
        <HeroSection onNavigate={scrollToSection} />
      </section>
      <section>
        <EditorialSection />
      </section>
      <section>
        <ProductGallery onNavigate={scrollToSection} />
      </section>
      <BrandPositioning onNavigate={scrollToSection} />
      <section>
        <CustomJewelrySection />
      </section>
      <VisualBreak />
      <section>
        <TestimonialsSection />
      </section>
      <CTASection onNavigate={scrollToSection} />
      <FooterSection onNavigate={scrollToSection} />
    </main>
  );
}
